import { bootApp } from "@empite/app-kit";
import { createAdminClient } from "./admin-client";

/**
 * The page's one QueryClient, one transport and one admin client.
 *
 * Module scope, built once, exactly as the customer portal does it: a client
 * built inside a component is rebuilt on every render, which throws the cache
 * away and turns a warm console into a cold one.
 *
 * The base URL is empty on purpose. The Vite dev server proxies /admin/v1 to
 * the Admin API's own deployment (see @empite/app-kit's portalViteConfig), so
 * the browser only ever talks to this portal's origin and
 * `esm_admin_session` stays a first-party cookie. Pointing the browser
 * straight at the API's port would make it third-party and the browser would
 * drop it — a sign-in that succeeds and a console that stays signed out.
 */
export const appContext = bootApp();

export const adminClient = createAdminClient(appContext.transport);
